import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      path: '',
      component: () =>
        import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          redirect: '/dashboard/campaign'
        },
        {
          path: '/dashboard/campaign',
          name: 'dashboard-campaign',
          component: () =>
            import('@/views/dashboard/DashboardCampaign.vue'),
          meta: {
            rule: 'retailer'
          }
        },
        {
          path: '/dashboard/campaigndata',
          name: 'dashboard-campaign-data',
          component: () =>
            import('@/views/dashboard/DashboardCampaignData.vue'),
          meta: {
            rule: 'retailer'
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () =>
            import('@/views/profile/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Profile', active: true }
            ],
            pageTitle: 'Profile',
            rule: 'retailer',
            showTitleBar: false
          }
        },
        {
          path: '/member/list',
          name: 'member-list',
          component: () =>
            import('@/views/member/MemberList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'OrganisationUser.List', active: true }
            ],
            pageTitle: 'OrganisationUser.List',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/campaign/list',
          name: 'campaign-list',
          component: () =>
            import('@/views/campaign/CampaignList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign.List', active: true }
            ],
            pageTitle: 'Campaign.List',
            rule: 'retailer',
            showTitleBar: false
          }
        },
        {
          path: '/order/list',
          name: 'order-list',
          component: () =>
            import('@/views/order/OrderGrid.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Order.List', active: true }
            ],
            pageTitle: 'Order.List',
            rule: 'retailer',
            showTitleBar: true
          }
        },
        {
          path: '/order/view/:orderId',
          name: 'order-view',
          component: () =>
            import('@/views/order/OrderViewPage.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Order.List', url: '/order/list' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Order.View',
            rule: 'retailer',
            showTitleBar: false
          }
        },
        {
          path: '/order/new',
          name: 'order-new',
          component: () =>
            import('@/views/order/OrderEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Order.List', url: '/order/list' },
              { title: 'New', active: true }
            ],
            pageTitle: 'Order.New',
            rule: 'admin',
            showTitleBar: true
          }
        },
        {
          path: '/order/edit/:orderId',
          name: 'order-edit',
          component: () =>
            import('@/views/order/OrderEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Order.List', url: '/order/list' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'Order.Edit',
            rule: 'admin',
            showTitleBar: true
          }
        },
        {
          path: '/retailer/list',
          name: 'retailer-list',
          component: () =>
            import('@/views/retailer/RetailerList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Retailer.List', active: true }
            ],
            pageTitle: 'Retailer.List',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/voucher/list',
          name: 'voucher-list',
          component: () =>
            import('@/views/voucher/VoucherList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Voucher.List', active: true }
            ],
            pageTitle: 'Voucher.List',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/campaign/view/:campaignId',
          name: 'campaign-view',
          component: () =>
            import('@/views/campaign/CampaignView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign.List', url: '/campaign/list' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Campaign.View',
            rule: 'retailer',
            showTitleBar: false
          }
        },
        {
          path: '/campaign/:campaignId/buysubscription',
          name: 'campaign-buy-subscription',
          component: () =>
            import('@/views/campaign/CampaignBuySubscription.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign.List', url: '/campaign/list' },
              { title: 'View', url: '/campaign/:campaignId/view' },
              { title: 'BuySubscription.Title', active: true }
            ],
            pageTitle: 'BuySubscription.Title',
            rule: 'retailer',
            showTitleBar: true
          }
        },
        {
          path: '/campaign/:campaignId/paymentfinished',
          name: 'campaign-payment-finished',
          component: () =>
            import('@/views/campaign/PaymentFinished.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign.List', url: '/campaign/list' },
              { title: 'PaymentFinished.Title', active: true }
            ],
            pageTitle: 'PaymentFinished.Title',
            rule: 'retailer',
            showTitleBar: true
          }
        },
        {
          path: '/campaign/images/:campaignId',
          name: 'campaign-images',
          component: () =>
            import('@/views/campaign/CampaignImages.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign.List', url: '/campaign/list' },
              { title: 'CampaignImage.List', active: true }
            ],
            pageTitle: 'CampaignImage.List',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/campaign/edit/:campaignId',
          name: 'campaign-edit',
          component: () =>
            import('@/views/campaign/CampaignEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign.List', url: '/campaign/list' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'Campaign.Edit',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/jobfeed/list',
          name: 'jobfeed-list',
          component: () =>
            import('@/views/jobfeed/JobFeedList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'JobFeed.List', active: true }
            ],
            pageTitle: 'JobFeed.List',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/jobfeed/view/:jobFeedId',
          name: 'jobfeed-view',
          component: () =>
            import('@/views/jobfeed/JobFeedView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'JobFeed.List', url: '/jobfeed/list' },
              { title: 'View', active: true }
            ],
            pageTitle: 'JobFeed View',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/jobfeed/new',
          name: 'jobfeed-new',
          component: () =>
            import('@/views/jobfeed/JobFeedEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'JobFeed.List', url: '/jobfeed/list' },
              { title: 'New', active: true }
            ],
            pageTitle: 'Jobfeed.New',
            rule: 'editor',
            showTitleBar: true
          }
        }, {
          path: '/jobfeed/edit/:jobFeedId',
          name: 'jobfeed-edit',
          component: () =>
            import('@/views/jobfeed/JobFeedEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'JobFeed.List', url: '/jobfeed/list' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'JobFeed.Edit',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/advertiser/list',
          name: 'advertiser-list',
          component: () =>
            import('@/views/advertiser/AdvertiserList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advertiser.List', active: true }
            ],
            pageTitle: 'Advertiser.List',
            rule: 'admin',
            showTitleBar: false
          }
        },
        {
          path: '/advertiser/view/:advertiserId',
          name: 'adveriser-view',
          component: () =>
            import('@/views/advertiser/AdvertiserView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advertiser.List', url: '/advertiser/list' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Advertiser.View',
            rule: 'admin',
            showTitleBar: false
          }
        },
        {
          path: '/advertiser/edit/:advertiserId',
          name: 'advertiser-edit',
          component: () =>
            import('@/views/advertiser/AdvertiserEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advertiser.List', url: '/advertiser/list' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'Advertiser.Edit',
            rule: 'admin',
            showTitleBar: true
          }
        },
        {
          path: '/advertiser/new',
          name: 'advertiser-new',
          component: () =>
            import('@/views/advertiser/AdvertiserEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advertiser.List', url: '/advertiser/list' },
              { title: 'New', active: true }
            ],
            pageTitle: 'Advertiser.New',
            rule: 'admin',
            showTitleBar: true
          }
        },
        {
          path: '/organisation/list',
          name: 'organisation-list',
          component: () =>
            import('@/views/organisation/OrganisationList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Organisation.List', active: true }
            ],
            pageTitle: 'Organisation.List',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/organisation/view/:organisationId',
          name: 'organisation-view',
          component: () =>
            import('@/views/organisation/OrganisationView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Organisation.List', url: '/organisation/list' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Organisation.View',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/organisation/edit/:organisationId',
          name: 'organisation-edit',
          component: () =>
            import('@/views/organisation/OrganisationEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Organisation.List', url: '/organisation/list' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'Organisation.Edit',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/articlelist/view/:articleListId',
          name: 'article-list-view',
          component: () =>
            import('@/views/article-list/ArticleListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ArticleList.List', url: '/articlelist/list' },
              { title: 'View', active: true }
            ],
            pageTitle: 'ArticleList.View',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/articlelist/edit/:articleListId',
          name: 'article-list-edit',
          component: () =>
            import('@/views/article-list/ArticleListEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ArticleList.List', url: '/articlelist/list' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'ArticleList.Edit',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/articlelist/new',
          name: 'article-list-new',
          component: () =>
            import('@/views/article-list/ArticleListEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ArticleList.List', url: '/articlelist/list' },
              { title: 'New', active: true }
            ],
            pageTitle: 'ArticleList.New',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/articlelist/list',
          name: 'article-list-list',
          component: () =>
            import('@/views/article-list/ArticleListList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'ArticleList.List', active: true }
            ],
            pageTitle: 'ArticleList.List',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/newsarticlelist/list',
          name: 'news-article-list-list',
          component: () =>
            import('@/views/news-article-list/NewsArticleListList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'NewsArticleList.List', active: true }
            ],
            pageTitle: 'NewsArticleList.List',
            rule: 'editor',
            showTitleBar: false
          }
        },
        {
          path: '/newsarticlelist/edit/:newsArticleListId',
          name: 'news-article-list-edit',
          component: () =>
            import('@/views/news-article-list/NewsArticleListEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'NewsArticleList.List', url: '/newsarticlelist/list' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'NewsArticleList.Edit',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/newsarticlelist/new',
          name: 'news-article-list-new',
          component: () =>
            import('@/views/news-article-list/NewsArticleListEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'NewsArticleList.List', url: '/newsarticlelist/list' },
              { title: 'New', active: true }
            ],
            pageTitle: 'NewsArticleList.New',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/organisation/new',
          name: 'organisation-new',
          component: () =>
            import('@/views/organisation/OrganisationEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Organisation.List', url: '/organisation/list' },
              { title: 'New', active: true }
            ],
            pageTitle: 'Organisation.New',
            rule: 'editor',
            showTitleBar: true
          }
        },
        {
          path: '/strategy/view/:strategyId',
          name: 'strategy-view',
          component: () =>
            import('@/views/strategy/StrategyView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Campaign', url: '/campaign/view/{id}' },
              { title: 'View', active: true }
            ],
            pageTitle: 'Strategy View',
            rule: 'editor',
            showTitleBar: false
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () =>
        import('@/layouts/full-page/FullPage.vue'),
      meta: {
        isPublic: true
      },
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/callback',
          name: 'auth-callback',
          component: () =>
            import('@/views/Callback.vue'),
          meta: {
            rule: 'editor',
            isPublic: true
          }
        },
        {
          path: '/login',
          name: 'login',
          component: () =>
            import('@/views/pages/login/Login.vue'),
          meta: {
            rule: "public",
            isPublic: true
          }
        },
        {
          path: '/register',
          name: 'page-register',
          component: () =>
            import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'public',
            isPublic: true
          }
        },
        {
          path: '/confirmemail',
          name: 'page-confirm-email',
          component: () =>
            import('@/views/pages/ConfirmEmail.vue'),
          meta: {
            rule: 'public',
            isPublic: true
          }
        },
        {
          path: '/forgot-password',
          name: 'page-forgot-password',
          component: () =>
            import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'public',
            isPublic: true
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () =>
            import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'public ',
            isPublic: true
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () =>
            import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/error-404',
          name: 'page-error-404',
          component: () =>
            import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor',
            isPublic: true
          }
        },
        {
          path: '/error-500',
          name: 'page-error-500',
          component: () =>
            import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor',
            isPublic: true
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () =>
            import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor',
            isPublic: true
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () =>
            import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor',
            isPublic: true
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404',
      isPublic: true
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {

  if (
    to.meta.isPublic ||
    (auth.isAuthenticated())
  ) {
    return next()
  }
  return next({ path: '/login', query: { to: to.path } })

})

export default router
